<template>
    <ItemMenuWrapper v-slot="{ inputId }" :label="label">
        <Dropdown :id="inputId" v-model="selectedValue" :options="options" optionLabel="label" optionValue="value" class="w-full" />
    </ItemMenuWrapper>
</template>

<script setup>
import ItemMenuWrapper from './ItemMenuWrapper.vue';
import { defineProps, defineEmits, computed } from 'vue';

const props = defineProps({
    modelValue: {
        type: [String, Boolean],
        default: null,
    },
    label: {
        type: String,
        required: true,
    },
    options: {
        type: Array,
        required: true,
    },
});

const emit = defineEmits(['update:modelValue']);

const selectedValue = computed({
    get: () => props.modelValue,
    set: (value) => {
        emit('update:modelValue', value);
    },
});
</script>
